export const siteNav = [
  { label: "首页", href: "#top" },
  { label: "热门合集", href: "#collections" },
  { label: "视频推荐", href: "#videos" },
  { label: "话题标签", href: "#topics" },
  { label: "热度榜单", href: "#ranking" },
  { label: "资源下载", href: "#download" },
];

export const hotSearch = [
  "年度高分电影",
  "治愈系纪录片",
  "动漫合集",
  "音乐现场",
  "游戏高光",
  "知识科普",
];

export const tickerItems = [
  "深海自然纪录片精选已更新至第 64 集",
  "年度高分电影合集 · 本周新增 12 部",
  "动漫资源合集按年代归档完成",
  "音乐现场混剪上线，支持高清播放",
  "游戏高光合辑 97 个已整理完毕",
  "知识科普专题新增 3 个系列",
];

export const heroLead = {
  tag: "本期封面",
  title: "在信息洪流里，先找到值得看的那个",
  desc: "91网把散落各处的热门视频与资源合集重新整理成一份可阅读的清单：先看推荐，再决定点开哪一个，省下反复搜索的时间。",
  meta: "编辑精选 · 12 个合集 · 本周更新",
  image:
    "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20magazine%20cover%20art%20with%20warm%20cream%20background%20and%20bold%20terracotta%20geometric%20shapes%2C%20muted%20amber%20highlights%2C%20fine%20grain%20texture%2C%20minimal%20sophisticated%20composition&width=1200&height=800&seq=91hero-lead-a&orientation=landscape",
};

export const heroCards = [
  {
    tag: "电影",
    title: "一口气看完的高分电影合集",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20art%20in%20warm%20clay%20tones%20with%20soft%20amber%20glow%2C%20minimal%20geometric%20arcs%2C%20cream%20paper%20background%2C%20editorial%20grain%20texture&width=600&height=800&seq=91hero-card-1&orientation=portrait",
  },
  {
    tag: "剧集",
    title: "本周追更最快的剧集清单",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20art%20with%20deep%20terracotta%20and%20burnt%20orange%20swashes%2C%20cream%20paper%20background%2C%20minimal%20editorial%20composition%2C%20fine%20grain&width=600&height=800&seq=91hero-card-2&orientation=portrait",
  },
  {
    tag: "纪录片",
    title: "治愈系自然纪录片精选",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20art%20with%20warm%20sand%20and%20amber%20layered%20waves%2C%20cream%20background%2C%20minimal%20editorial%20poster%2C%20soft%20grain%20texture&width=600&height=800&seq=91hero-card-3&orientation=portrait",
  },
  {
    tag: "动漫",
    title: "经典动漫资源一次收齐",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20art%20with%20muted%20rust%20and%20gold%20concentric%20circles%2C%20cream%20paper%20background%2C%20minimal%20magazine%20cover%2C%20fine%20grain&width=600&height=800&seq=91hero-card-4&orientation=portrait",
  },
];

export const collections = [
  {
    title: "年度高分电影合集",
    count: "128 部",
    desc: "按口碑与热度重新排序，省去来回搜索的时间。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinema%20poster%20art%20in%20warm%20crimson%20and%20cream%2C%20minimal%20film%20reel%20geometry%2C%20soft%20grain%2C%20editorial%20magazine%20cover&width=600&height=800&seq=91col-1&orientation=portrait",
  },
  {
    title: "经典剧集一口气看完",
    count: "86 部",
    desc: "已完结优先，适合周末连续观看。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20series%20cover%20art%20with%20warm%20amber%20and%20clay%20blocks%2C%20cream%20background%2C%20minimal%20editorial%2C%20fine%20grain%20texture&width=600&height=800&seq=91col-2&orientation=portrait",
  },
  {
    title: "治愈系纪录片精选",
    count: "64 部",
    desc: "自然、人文与生活纪实，节奏舒缓。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20documentary%20cover%20art%20with%20earthy%20terracotta%20mountain%20silhouette%2C%20cream%20background%2C%20minimal%20poster%2C%20soft%20grain&width=600&height=800&seq=91col-3&orientation=portrait",
  },
  {
    title: "动漫资源合集",
    count: "152 部",
    desc: "按年代与题材归档，更新稳定。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20anime%20cover%20art%20with%20warm%20coral%20and%20gold%20curves%2C%20cream%20background%2C%20minimal%20editorial%2C%20fine%20grain&width=600&height=800&seq=91col-4&orientation=portrait",
  },
  {
    title: "音乐现场高燃混剪",
    count: "210 段",
    desc: "演唱会与音乐节现场，音质清晰。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20music%20cover%20art%20with%20warm%20rust%20soundwave%20ribbons%2C%20cream%20background%2C%20minimal%20poster%2C%20soft%20grain%20texture&width=600&height=800&seq=91col-5&orientation=portrait",
  },
  {
    title: "游戏高光实况合集",
    count: "97 个",
    desc: "热门游戏实况与操作高光，节奏紧凑。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20gaming%20cover%20art%20with%20warm%20orange%20gradient%20shapes%2C%20cream%20background%2C%20minimal%20editorial%20cover%2C%20fine%20grain&width=600&height=800&seq=91col-6&orientation=portrait",
  },
];

export const hotVideos = [
  {
    tag: "纪录片",
    title: "深海之下：未被记录的自然奇观",
    duration: "12:40",
    plays: "238万",
    author: "自然观察局",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20warm%20amber%20glow%20and%20terracotta%20shapes%2C%20cream%20background%2C%20minimal%20editorial%2C%20fine%20grain&width=600&height=800&seq=91vid-1&orientation=portrait",
  },
  {
    tag: "电影",
    title: "如何用十分钟判断一部电影值不值得看",
    duration: "09:18",
    plays: "186万",
    author: "放映室笔记",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20muted%20rust%20and%20cream%20stripes%2C%20minimal%20geometry%2C%20soft%20grain%20texture&width=600&height=800&seq=91vid-2&orientation=portrait",
  },
  {
    tag: "动漫",
    title: "这一季最被低估的三部新番",
    duration: "07:52",
    plays: "152万",
    author: "番剧速递",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20warm%20gold%20sunburst%20pattern%2C%20cream%20background%2C%20minimal%20poster%2C%20fine%20grain&width=600&height=800&seq=91vid-3&orientation=portrait",
  },
  {
    tag: "音乐",
    title: "现场混剪：那些一开口就起鸡皮的瞬间",
    duration: "15:06",
    plays: "121万",
    author: "声场现场",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20deep%20clay%20waves%20and%20amber%20dots%2C%20cream%20background%2C%20minimal%20editorial%2C%20soft%20grain&width=600&height=800&seq=91vid-4&orientation=portrait",
  },
  {
    tag: "知识",
    title: "把复杂讲简单：十分钟看懂一个行业",
    duration: "10:33",
    plays: "98万",
    author: "知识补给站",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20warm%20coral%20gradient%20blobs%2C%20cream%20background%2C%20minimal%20poster%2C%20fine%20grain%20texture&width=600&height=800&seq=91vid-5&orientation=portrait",
  },
  {
    tag: "游戏",
    title: "本周高光操作合辑，最后一个封神",
    duration: "08:47",
    plays: "134万",
    author: "像素工坊",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20terracotta%20and%20sand%20geometric%20grid%2C%20cream%20background%2C%20minimal%20editorial%2C%20soft%20grain&width=600&height=800&seq=91vid-6&orientation=portrait",
  },
  {
    tag: "生活",
    title: "城市漫游：一条街的十二小时",
    duration: "11:21",
    plays: "76万",
    author: "慢速生活",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20warm%20rust%20concentric%20rings%2C%20cream%20background%2C%20minimal%20poster%2C%20fine%20grain%20texture&width=600&height=800&seq=91vid-7&orientation=portrait",
  },
  {
    tag: "综艺",
    title: "名场面回顾：那些反复被剪辑的片段",
    duration: "13:15",
    plays: "88万",
    author: "弹幕观察员",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20video%20cover%20art%20with%20amber%20and%20clay%20diagonal%20bands%2C%20cream%20background%2C%20minimal%20editorial%2C%20soft%20grain&width=600&height=800&seq=91vid-8&orientation=portrait",
  },
];

export const topics = [
  { text: "年度佳片", size: "lg" },
  { text: "高分电影", size: "md" },
  { text: "一口气看完", size: "lg" },
  { text: "治愈系", size: "sm" },
  { text: "纪录片", size: "md" },
  { text: "动漫资源", size: "md" },
  { text: "新番速递", size: "sm" },
  { text: "音乐现场", size: "md" },
  { text: "高燃混剪", size: "sm" },
  { text: "游戏实况", size: "md" },
  { text: "高光操作", size: "sm" },
  { text: "知识科普", size: "md" },
  { text: "行业解读", size: "sm" },
  { text: "生活Vlog", size: "sm" },
  { text: "城市漫游", size: "sm" },
  { text: "旅行风光", size: "md" },
  { text: "美食探店", size: "sm" },
  { text: "数码评测", size: "sm" },
  { text: "体育集锦", size: "sm" },
  { text: "综艺名场面", size: "md" },
  { text: "悬疑推理", size: "sm" },
  { text: "科幻片单", size: "sm" },
  { text: "经典重映", size: "sm" },
  { text: "冷门佳片", size: "lg" },
  { text: "周末片单", size: "md" },
];

export const rankings = [
  { rank: 1, title: "年度高分电影合集", tag: "电影", hot: "98.6", trend: "up" },
  { rank: 2, title: "治愈系纪录片精选", tag: "纪录片", hot: "95.2", trend: "up" },
  { rank: 3, title: "经典剧集一口气看完", tag: "剧集", hot: "92.8", trend: "flat" },
  { rank: 4, title: "动漫资源合集", tag: "动漫", hot: "90.1", trend: "up" },
  { rank: 5, title: "游戏高光实况合集", tag: "游戏", hot: "87.4", trend: "down" },
  { rank: 6, title: "音乐现场高燃混剪", tag: "音乐", hot: "84.9", trend: "up" },
  { rank: 7, title: "知识科普精选合集", tag: "知识", hot: "81.3", trend: "flat" },
  { rank: 8, title: "生活Vlog精选合集", tag: "生活", hot: "78.6", trend: "up" },
];

export const downloadItems = [
  {
    icon: "ri-android-line",
    name: "91网 安卓客户端",
    size: "v3.2.1 · 28.4 MB",
    desc: "支持离线缓存合集列表与一键订阅更新，更新提醒更及时。",
    tag: "推荐",
  },
  {
    icon: "ri-apple-fill",
    name: "91网 iOS 客户端",
    size: "v3.2.0 · 42.1 MB",
    desc: "适配深色模式，收藏夹与网页端自动同步，浏览更顺手。",
    tag: "新版",
  },
  {
    icon: "ri-computer-line",
    name: "91网 桌面版",
    size: "v2.8.5 · 61.7 MB",
    desc: "大屏浏览更舒适，支持多标签收藏与快捷搜索。",
    tag: "",
  },
  {
    icon: "ri-file-list-3-line",
    name: "本周资源清单",
    size: "PDF · 3.1 MB",
    desc: "一键导出本周全部推荐合集与内容索引，方便离线查看。",
    tag: "运营精选",
  },
];

export const editorPicks = [
  {
    kicker: "编辑手记",
    title: "为什么我们坚持先做减法，再做推荐",
    desc: "面对海量内容，推荐的价值不在于给你更多，而在于帮你更快地筛选掉不值得看的那些。",
    meta: "阅读 12 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20spread%20art%20with%20warm%20terracotta%20and%20cream%20paper%20texture%2C%20minimal%20geometric%20layout%2C%20soft%20grain&width=1200&height=800&seq=91editor-1&orientation=landscape",
  },
  {
    kicker: "本期专题",
    title: "把「想看的」变成一份可以读完的清单",
    desc: "我们按题材、时长与更新节奏重新编排合集，让每一次点开都更接近你想看的内容。",
    meta: "收录 42 个合集",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20spread%20art%20with%20warm%20amber%20gradient%20and%20cream%20paper%2C%20minimal%20shapes%2C%20fine%20grain%20texture&width=1200&height=800&seq=91editor-2&orientation=landscape",
  },
  {
    kicker: "幕后",
    title: "一份合集从收录到上架，要经过几道关",
    desc: "从信息核对到标签归类，再到画质与可看性的初筛，每一步都决定它是否值得出现在首页。",
    meta: "阅读 8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20spread%20art%20with%20muted%20rust%20and%20sand%20tones%2C%20cream%20paper%20background%2C%20minimal%20layout%2C%20soft%20grain&width=1200&height=800&seq=91editor-3&orientation=landscape",
  },
];

export const footerStats = [
  { label: "收录合集", value: "2,180+" },
  { label: "精选视频", value: "16,400+" },
  { label: "每日更新", value: "300+" },
  { label: "话题标签", value: "520+" },
];

export const footerColumns = [
  {
    title: "热门标签",
    links: ["高分电影", "剧集追更", "动漫资源", "综艺看点", "纪录片"],
  },
  {
    title: "内容分区",
    links: ["影视合集", "音乐现场", "游戏实况", "知识科普", "生活Vlog"],
  },
  {
    title: "关于91网",
    links: ["关于我们", "联系方式", "版权声明", "用户协议", "隐私政策"],
  },
  {
    title: "帮助中心",
    links: ["新手引导", "下载安装", "常见问题", "意见反馈", "资源收录"],
  },
];